<template>

    <v-form ref="issueScheduleDetailsForm" class="fill-height" :lazy-validation="true" v-model="issueScheduleDetailsFormValid">
        <v-row>
            <v-col cols="12" sm="6">
                <v-select label="Recurs" v-model="recurType" color="#c42111" :items="recurOptions" />
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu v-model="editScheduleTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="scheduleTime" color="#c42111" label="After This Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                    </template>
                    <v-time-picker v-model="scheduleTime" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                </v-menu>
            </v-col>

            <v-col cols="12" sm="2" class="text-left mt-6">
                <span>Repeat every: </span>
            </v-col>
            <v-col cols="12" sm="2">
                <v-select class="text-left" v-model="recurFrequency" color="#c42111" :items="recurFrequencyOptions" />
            </v-col>
            <v-col cols="12" sm="2" class="text-left mt-6">
                {{recurTypeText}}
            </v-col>

            <v-col cols="12" sm="6" v-if="recurType == 'Weekly' || recurType == 'Monthly'">
                <v-select label="Repeat on" v-model="selectedWeekdays" color="#c42111" :items="weekDayOptions" multiple v-if="recurType == 'Weekly'" :rules="[validation.weekdayRequired(recurType, selectedWeekdays)]" />
                <v-select label="Repeat on" v-model="selectedMonthDay" color="#c42111" :items="monthDayOptions" v-if="recurType == 'Monthly'" />
            </v-col>

            <v-col cols="12" sm="5">
                <v-menu v-model="editStartDate" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="startDate" color="#c42111" label="Starts On" prepend-icon="event" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" color="#c42111" scrollable />
                </v-menu>
            </v-col>

            <v-col cols="12" sm="2">
                <v-switch color="#c42111" :label="neverEnds ? 'Never Ends' : 'Until'" v-model="neverEnds" />
            </v-col>

            <v-col cols="12" sm="5">
                <v-menu v-model="editEndDate" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="endDate" color="#c42111" label="Ends On" prepend-icon="event" readonly v-on="on" :disabled="neverEnds" :rules="[validation.dateOrder(startDate, endDate, neverEnds)]"></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" color="#c42111" scrollable />
                </v-menu>
            </v-col>


            <v-col cols="12" sm="6">
                <v-switch style="display: inline-block; vertical-align: middle;" color="#c42111" label="Create a separate issue for each site" v-model="$props.issue.schedule.issue_per_site" />
                <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on }">
                        <v-icon class="ml-2" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>If enabled, the system will create a saparate issue for every site listed in Sites Affected. For example, if you had 100 sites in Sites Affected and scheduled the issue to occur every month, the system would create 100 separate tickets every month.</span>
                </v-tooltip>
            </v-col>
            <v-col cols="12" sm="6">
                <v-switch style="display: inline-block; vertical-align: middle;" color="#c42111" label="Assign site technician as issue owner" v-model="$props.issue.schedule.issue_owner_site_technician" :disabled="!$props.issue.schedule.issue_per_site" />
                <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on }">
                        <v-icon :disabled="!$props.issue.schedule.issue_per_site" class="ml-2" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>If enabled, the system will set the Issue Owner, for each ticket created for each affected site, to that site's assigned site technician. If the site doesn't have a site technician assigned, then it will set the Issue Owner to the Issue Owner defined in this Recurring Issue template.</span>
                </v-tooltip>
            </v-col>

        </v-row>
    </v-form>

</template>

<script>
export default {
    name: 'ScheduleDetails',
    props: ['issue'],
    components: {
    },
    data: () => ({
        issueScheduleDetailsFormValid: true,
        recurOptions: ['Daily', 'Weekly', 'Monthly', 'Yearly'],
        weekDayOptions: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        recurFrequencyOptions: [],
        monthDayOptions: [],
        editScheduleTime: false,
        editStartDate: false,
        editEndDate: false,

        recurType: "Daily",
        recurFrequency: "1",

        selectedWeekdays: [],
        selectedMonthDay: "1",

        scheduleTime: "",
        startDate: "",
        endDate: "",
        neverEnds: false,

        validation: {
            dateOrder: (start, end, neverEnds) => ((start < end) || (neverEnds) || `End date must be after Start date`),
            weekdayRequired: (recurType, selectedWeekdays) => (recurType != 'Weekly' || !!selectedWeekdays.length || `You must select at least 1 weekday`),
        },
    }),

    computed: {
        recurTypeText: function() {
            if(this.recurType == 'Daily') {
                return 'days';
            }
            else if(this.recurType == 'Weekly') {
                return 'weeks';
            }
            else if(this.recurType == 'Monthly') {
                return 'months';
            }
            else if(this.recurType == 'Yearly') {
                return 'years';
            }
        }
    },

    methods: {
        validate: function() {
            return this.$refs.issueScheduleDetailsForm.validate();
        },

        setupInitialValues: function() {
            for(let i = 1; i <= 30; i++) {
                this.recurFrequencyOptions.push(i.toString());
                this.monthDayOptions.push(i.toString());
            }
            this.recurType = this.$props.issue.schedule.sche_parameter.split(';')[0];
            this.recurFrequency = this.$props.issue.schedule.sche_parameter.split(';')[1];
            if(this.recurType == 'Weekly') {
                let daysBool = this.$props.issue.schedule.sche_parameter.split(';')[2];                
                if(daysBool.split(',')[0] == 'True') {this.selectedWeekdays.push('Monday');}
                if(daysBool.split(',')[1] == 'True') {this.selectedWeekdays.push('Tuesday');}
                if(daysBool.split(',')[2] == 'True') {this.selectedWeekdays.push('Wednesday');}
                if(daysBool.split(',')[3] == 'True') {this.selectedWeekdays.push('Thursday');}
                if(daysBool.split(',')[4] == 'True') {this.selectedWeekdays.push('Friday');}
                if(daysBool.split(',')[5] == 'True') {this.selectedWeekdays.push('Saturday');}
                if(daysBool.split(',')[6] == 'True') {this.selectedWeekdays.push('Sunday');}
            }
            else if(this.recurType == 'Monthly') {
                this.selectedMonthDay = this.$props.issue.schedule.sche_parameter.split(';')[2];
            }
            this.scheduleTime = TELSA.moment(this.$props.issue.schedule.sche_time, 'h:mm:ss A').format('HH:mm:ss');
            this.startDate = this.$props.issue.schedule.sche_start_time;
            this.endDate = this.$props.issue.schedule.sche_end_time;
            this.neverEnds = (!this.$props.issue.schedule.sche_end_time);
        },

        computeScheParam: function() {
            let val3 = '';
            if(this.recurType == 'Weekly') {
                val3 += (this.selectedWeekdays.includes('Monday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Tuesday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Wednesday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Thursday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Friday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Saturday') ? 'True,' : 'False,');
                val3 += (this.selectedWeekdays.includes('Sunday') ? 'True,' : 'False,');
            }
            else if(this.recurType == 'Monthly') {
                val3 = this.selectedMonthDay;
            }
            this.$props.issue.schedule.sche_parameter = `${this.recurType};${this.recurFrequency};${val3};`;
        }
    },

    watch: {
        recurType: {
            handler(newVal, oldVal) {
                this.computeScheParam();
            }
        },
        recurFrequency: {
            handler(newVal, oldVal) {
                this.computeScheParam();
            }
        },
        selectedWeekdays: {
            handler(newVal, oldVal) {
                this.computeScheParam();
            }
        },
        selectedMonthDay: {
            handler(newVal, oldVal) {
                this.computeScheParam();
            }
        },

        scheduleTime: {
            handler(newVal, oldVal) {
                this.$props.issue.schedule.sche_time = TELSA.moment(newVal, 'HH:mm:ss').format('hh:mm:ss A');
            }
        },

        startDate: {
            handler(newVal, oldVal) {
                this.$props.issue.schedule.sche_start_time = this.startDate;
            }
        },

        neverEnds: {
            handler(newVal, oldVal) {
                this.$props.issue.schedule.sche_end_time = this.neverEnds ? '' : this.endDate;
            }
        },
        endDate: {
            handler(newVal, oldVal) {
                this.$props.issue.schedule.sche_end_time = this.neverEnds ? '' : this.endDate;
            }
        },

        issue: {
            handler(newVal, oldVal) {
                if(!newVal.schedule.issue_per_site) {
                    this.$props.issue.schedule.issue_owner_site_technician = false;
                }
            },
            deep: true
        }
    },

    created() {
        this.setupInitialValues();
    },

    mounted() {
    }


};
</script>

<style scoped>

</style>
